import { render, staticRenderFns } from "./ProductSection.vue?vue&type=template&id=39cc17ea&"
import script from "./ProductSection.vue?vue&type=script&lang=ts&"
export * from "./ProductSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports